import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';

export const getAllVendorFunction = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/vendor?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        // toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}